import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const ProviderConditions = 'ProviderConditions'

export const getProviderConditions = (providerId) => {
  return axios.get(`/${ProviderConditions}?providerId=${providerId}`)
}

export const createProviderConditionsApprovals = (data) => {
  return axios.post(`/${ProviderConditions}`, data)
}
